import React from 'react'
import { useMutation } from '@apollo/react-hooks'
import {
  Col, Switch, Select, Input, message,
} from 'antd'
import * as UI from 'konsys-ui'
import _ from 'lodash'
import { detailMode } from '../constants'
import { UploadWithModal } from '../../../components/common'
import { ACTIVATE_GAS_STATION } from '../../../constants/graphql/mutation'
import PERMISSION from '../../../constants/permissions'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Upload box
5: Select
6: TextArea
7: Upload
*/

const CompanyList = ['SHELL', 'BANGCHAK', 'CALTEX', 'ESSO', 'PTT', 'PT', 'OTHER']

const CreateMode = ({ data, onChangeHandler }) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}><UI.InputWithLabel {...data.props} width='100%' input={{ onChange: e => onChangeHandler(data.id, e.target.value), ...data.props.input }} /></Col>
      )
    case 1:
      return <UI.Input {...data.props} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return <UI.Select dropdown buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: data.children[0].text }} data={data.children} {...data.props} />
    case 4:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            listType='picture'
            button={data.props}
          />
        </Col>
      )
    case 5:
      return (
        <Col
          span={data.span}
          style={{}}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='8px 0 16px'>{data.props.title.text}</UI.P>
            <Select
              showSearch
              defaultValue="กรุณาเลือกบริษัท"
              onChange={(e) => {
                onChangeHandler(data.id, e)
              }}
            >
            {
              CompanyList.map((v, i) => <Select.Option key={i} value={v}>{v}</Select.Option>)
            }
            </Select>
          </UI.Div>
        </Col>
      )
    case 6:
      return <Col
          span={data.span}
          style={{ alignSelf: 'flex-end' }}
        >
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <Input.TextArea {...data.props} onChange={e => onChangeHandler(data.id, e.target.value)}/>
          </UI.Div>
        </Col>
    case 7:
      return (
        <Col span={data.span}>
          <UploadWithModal
            onChange={(e) => {
              onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))
            }
            }
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            listType='picture'
            button={data.props}
          />
        </Col>
      )
    case 8:
      return <UI.Div/>
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, initialData, onChangeHandler,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.InputWithLabel width='100%' {...data.props} input={{
            disabled,
            defaultValue: initialData[data.id],
            onChange: e => onChangeHandler(data.id, e.target.value),
            ...data.props.input,
          }} />
        </Col>
      )
    case 1:
      return <UI.Input disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return (
        <UI.Select
          dropdown
          buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: initialData[data.id] }}
          data={data.children}
          disabled={disabled} {...data.props}
        />
      )
    case 4:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            listType='picture'
            button={data.props}
          />
        </Col>
      )
    case 5:
      return (
          <Col
            span={data.span}
            style={{}}
          >
            <UI.Div display='flex' flexDirection='column' margin='0'>
              <UI.P margin='8px 0 16px'>{data.props.title.text}</UI.P>
              <Select
                showSearch
                disabled={disabled}
                defaultValue={initialData[data.id]}
                onChange={(e) => {
                  onChangeHandler(data.id, e)
                }}
              >
              {
                CompanyList.map((v, i) => <Select.Option key={i} value={v}>{v}</Select.Option>)
              }
              </Select>
            </UI.Div>
          </Col>
      )
    case 6:
      return <Col
        span={data.span}
        style={{ alignSelf: 'flex-end' }}
      >
        <UI.Div display='flex' flexDirection='column'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)}/>
        </UI.Div>
      </Col>
    case 7:
      return (
        <Col span={data.span}>
          <UploadWithModal
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            showUploadList={{
              showRemoveIcon: !disabled,
            }}
            defaultFileList={!_.isNull(initialData[data.id]) && initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={(e) => {
              onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))
            }}
            listType='picture'
            button={data.props}
          />
        </Col>
      )
    case 8: {
      const [doActivate, { loading: activateLoading }] = useMutation(ACTIVATE_GAS_STATION)
      return (
        <Col span={data.span} offset={data.offset}>
          <Switch
            defaultChecked={initialData[data.id]}
            loading={activateLoading}
            disabled={disabled || !_.includes(window.perms, PERMISSION.ACTIVATE_GAS_STATION)}
            onChange={(e) => {
              doActivate({
                variables: {
                  id: initialData.id,
                  isActive: e,
                },
              }).then((resp) => {
                if (resp?.data?.ActivateGasstation?.success) {
                  message.success(resp?.data?.ActivateGasstation?.message)
                } else {
                  message.error(resp?.data?.ActivateGasstation?.message)
                }
              })
            }}
          />
        </Col>
      )
    }
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.EDIT:
      return <EditMode data={data} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.VIEW:
      return <EditMode data={data} disabled={true} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    default:
      return <p>no mode</p>
  }
}
